(() => {
  const PAGE_SELECTOR = 'main[data-template="page.high-jewelry"]';
  const ROOT_SELECTOR = '.tooto-high-jewelry-page';
  const TARGET_CLASS = 'tooto-high-jewelry-motion-target';
  const VISIBLE_CLASS = 'is-tooto-motion-visible';
  const STYLE_ID = 'tooto-high-jewelry-motion-styles';

  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      @media (prefers-reduced-motion: no-preference) {
        ${PAGE_SELECTOR} .${TARGET_CLASS} {
          --tooto-high-jewelry-motion-duration: 920ms;
          --tooto-high-jewelry-motion-easing: cubic-bezier(0.22, 0.61, 0.36, 1);
        }

        ${PAGE_SELECTOR} .${TARGET_CLASS}.tooto-high-jewelry-motion-media .tooto-high-jewelry-page__image {
          opacity: 0;
          transform: scale(1.035);
          transform-origin: center center;
          transition:
            opacity var(--tooto-high-jewelry-motion-duration) var(--tooto-high-jewelry-motion-easing),
            transform 1200ms var(--tooto-high-jewelry-motion-easing);
          will-change: opacity, transform;
        }

        ${PAGE_SELECTOR} .tooto-high-jewelry-motion-text {
          opacity: 0;
          transform: translate3d(0, 18px, 0);
          transition:
            opacity 680ms var(--tooto-high-jewelry-motion-easing),
            transform 760ms var(--tooto-high-jewelry-motion-easing);
          transition-delay: var(--tooto-high-jewelry-text-delay, 180ms);
          will-change: opacity, transform;
        }

        ${PAGE_SELECTOR} .tooto-high-jewelry-page__caption.tooto-high-jewelry-motion-text {
          transform: translate3d(-50%, 18px, 0);
        }

        ${PAGE_SELECTOR} .${TARGET_CLASS}.${VISIBLE_CLASS}.tooto-high-jewelry-motion-media .tooto-high-jewelry-page__image,
        ${PAGE_SELECTOR} .${TARGET_CLASS}.${VISIBLE_CLASS} .tooto-high-jewelry-motion-text {
          opacity: 1;
          transform: none;
        }

        ${PAGE_SELECTOR} .${TARGET_CLASS}.${VISIBLE_CLASS} .tooto-high-jewelry-page__caption.tooto-high-jewelry-motion-text {
          transform: translateX(-50%);
        }

        ${PAGE_SELECTOR} .${TARGET_CLASS}.${VISIBLE_CLASS}.tooto-high-jewelry-motion-media .tooto-high-jewelry-page__image,
        ${PAGE_SELECTOR} .${TARGET_CLASS}.${VISIBLE_CLASS} .tooto-high-jewelry-motion-text {
          will-change: auto;
        }
      }
    `;
    document.head.append(style);
  };

  const addTextMotion = (nodes) => {
    nodes.forEach((node, index) => {
      if (!(node instanceof HTMLElement)) return;
      node.classList.add('tooto-high-jewelry-motion-text');
      node.style.setProperty('--tooto-high-jewelry-text-delay', `${180 + index * 120}ms`);
    });
  };

  const prepareTarget = (target) => {
    if (!(target instanceof HTMLElement)) return;
    if (target.dataset.tootoHighJewelryMotion === 'true') return;

    target.dataset.tootoHighJewelryMotion = 'true';
    target.classList.add(TARGET_CLASS);

    if (target.classList.contains('tooto-high-jewelry-page__band')) {
      target.classList.add('tooto-high-jewelry-motion-media');
      addTextMotion(Array.from(target.querySelectorAll('.tooto-high-jewelry-page__caption')));
      return;
    }

    addTextMotion(
      Array.from(
        target.querySelectorAll(
          [
            '.tooto-high-jewelry-page__eyebrow',
            '.tooto-high-jewelry-page__description',
            '.tooto-high-jewelry-page__statement-eyebrow',
            '.tooto-high-jewelry-page__statement-heading'
          ].join(',')
        )
      )
    );
  };

  const revealTarget = (target) => {
    if (!(target instanceof HTMLElement)) return;
    target.classList.add(VISIBLE_CLASS);
  };

  const getTargets = (page) => {
    const root = page.querySelector(ROOT_SELECTOR);
    if (!root) return [];

    return [
      root.querySelector('.tooto-high-jewelry-page__intro-copy'),
      ...root.querySelectorAll('.tooto-high-jewelry-page__band'),
      root.querySelector('.tooto-high-jewelry-page__statement')
    ].filter((target) => target instanceof HTMLElement);
  };

  const init = () => {
    const page = document.querySelector(PAGE_SELECTOR);
    if (!page) return;

    injectStyles();

    const targets = getTargets(page);
    targets.forEach(prepareTarget);

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      targets.forEach(revealTarget);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          revealTarget(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.28
      }
    );

    targets.forEach((target) => observer.observe(target));
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
